import React from 'react';
import FormQuestion from './FormQuestion/FormQuestion';
import { getDefaultValue } from './FormQuestion/helpers';
import { FormQuestionsRender } from './FormQuestion/types';

const FormNonLazyQuestionsRender = ({ questions: nonLazyQuestions, currentPage, previousPage, onQuestionSubmit, formsAnswers }: FormQuestionsRender) => {
  return (
    <>
      {nonLazyQuestions.map((item, index) => {
        const defaultValue = getDefaultValue(item, formsAnswers, nonLazyQuestions);
        return (
          currentPage === index && (
            <FormQuestion key={item.question.id} item={item} registerAs={`question${index}`} onQuestionSubmit={onQuestionSubmit} previousPage={previousPage} defaultValue={defaultValue} />
          )
        );
      })}
    </>
  );
};

export default FormNonLazyQuestionsRender;
